"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AddQuoteDetails_1 = __importDefault(require("../Utils/AddQuoteDetails"));
var FormatCurrency_1 = require("@CommonFrontend/Utils/FormatCurrency");
var StripeElements_1 = __importDefault(require("@CommonFrontend/CreditCardForm/StripeElements"));
var StripePayment_1 = require("@CommonFrontend/CreditCardForm/StripePayment");
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var PayNow = (function () {
    function PayNow(createUi, make, stripePublicKey, payNowSettings, isGroupAccept, setErrorMsg, di, projectTotal, projectCurrencies, publicApiBaseUrl, projectCreatorProfile, usingFeature) {
        var _this = this;
        var isUsingInlineForm = !usingFeature(FeatureFlag_1.default.OptOutNewEditor);
        var addPaymentUrl = "".concat(publicApiBaseUrl, "/projects/").concat(projectCreatorProfile.secret, "/add-payment");
        var stripeUserId = di.has("stripeUserId") ? di.get("stripeUserId") : null;
        var stripeElements = make(StripeElements_1.default, {
            stripeKey: stripePublicKey,
            stripeUserId: stripeUserId,
            showEmailField: isGroupAccept,
            setErrorMsg: setErrorMsg,
            useUpdatedStyling: isUsingInlineForm,
        });
        var isPartial = function () {
            return payNowSettings.enablePartPayment &&
                0 < payNowSettings.partPaymentPercentage &&
                payNowSettings.partPaymentPercentage < 100;
        };
        var getCurrencyCode = function () {
            try {
                return projectCurrencies.getSingleCurrency();
            }
            catch (error) {
                return "AUD";
            }
        };
        var payNowAmount = function () {
            var singleCurrencyTotal = projectTotal.calculatePayTodaySingleCurrency();
            if (singleCurrencyTotal != null) {
                if (isPartial()) {
                    return (singleCurrencyTotal * payNowSettings.partPaymentPercentage) / 100;
                }
                else {
                    return singleCurrencyTotal;
                }
            }
            else {
                return 0;
            }
        };
        var isOptional = function () { return payNowSettings.enableOptionalPayment; };
        var shouldSkipOptionalPayment = function () { return isOptional() && stripeElements.isFormEmpty(); };
        var isPreview = di.has("isPreviewMode") ? di.get("isPreviewMode") : false;
        this.name = "payNow";
        this.ui = createUi(require("./PayNowForm.html"), {
            form: stripeElements.ui,
            totalAmount: payNowAmount(),
            formattedAmount: function () {
                return (0, FormatCurrency_1.formatCurrency)(payNowAmount(), getCurrencyCode());
            },
            businessName: payNowSettings.businessName,
            paymentInfo: payNowSettings.paymentInfo,
            currencyCode: getCurrencyCode,
            isOptional: isOptional,
            isPartial: isPartial,
            partialAmount: function () {
                return payNowSettings.partPaymentPercentage;
            },
            isGroupAccept: function () {
                return isGroupAccept;
            },
            isPreview: isPreview,
            isUsingInlineForm: isUsingInlineForm,
        });
        this.validate = function () {
            if (shouldSkipOptionalPayment()) {
                return true;
            }
            return stripeElements.validateForm();
        };
        this.finalise = function (acceptData) {
            if (isPreview || shouldSkipOptionalPayment()) {
                return;
            }
            return stripeElements
                .createCardPayment()
                .then(function (info) {
                acceptData.payment = {
                    paymentMethodId: info.paymentMethodId,
                    amount: payNowAmount(),
                    currency: _this.ui.currencyCode(),
                    name: info.name,
                    email: info.email,
                };
            })
                .then(function () {
                acceptData.sessionStartedAt = window.sessionStartTime;
                di.invoke(AddQuoteDetails_1.default, null, { acceptData: acceptData });
                return (0, StripePayment_1.attemptRequestWithPayment)(addPaymentUrl, stripeElements, acceptData);
            });
        };
        this.devFill = function () { return stripeElements.useTestCard(); };
        this.previewAutoFill = function () { return stripeElements.useTestCard(); };
    }
    return PayNow;
}());
exports.default = PayNow;
